import { ControlProperty } from '../../../../../common/models';
import { DEFAULT_NUMBER_VALIDATORS, TIME_PATTERN, TruckSize } from '../../../../../common/constants';
import { Validators } from '@angular/forms';

export class HubTrucksSize {
  byDefault: boolean;
  handlingUnitEffort: number;
  loadingMeterEffort: number;
  mappingNames: string[];
  maxHandlingUnits: number;
  maxLoadingMeters: number;
  sizeType: TruckSize;

  constructor(params?: HubTrucksSize) {
    if (params) {
      Object.assign(this, params);
    }
  }
}

export interface HubTrucksModel {
  l: HubTrucksSize;
  m: HubTrucksSize;
  s: HubTrucksSize;
  xl: HubTrucksSize;
  xxl: HubTrucksSize;
}

export class HubTrucksForm {
  constructor(
    model: HubTrucksSize,
    public sizeType: ControlProperty<string> = model.sizeType,

    public byDefault: ControlProperty<boolean> = [model.byDefault, [Validators.required]],
    public handlingUnitEffort: ControlProperty<number> = [
      model.handlingUnitEffort,
      [Validators.required, Validators.pattern(TIME_PATTERN)],
    ],
    public loadingMeterEffort: ControlProperty<number> = [
      model.loadingMeterEffort,
      [Validators.required, Validators.pattern(TIME_PATTERN)],
    ],
    public mappingNames: ControlProperty<string[]> = [model.mappingNames, []],
    public maxHandlingUnits: ControlProperty<number> = [model.maxHandlingUnits, DEFAULT_NUMBER_VALIDATORS],
    public maxLoadingMeters: ControlProperty<number> = [model.maxLoadingMeters, DEFAULT_NUMBER_VALIDATORS],
  ) {}
}
